import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { theme } from '@styles/theme';

const Surface = styled.aside`
  min-width: 0;
  text-align: center;
`;

const Text = styled.p`
  min-width: 0;
  margin: 0;
  color: ${theme.colors.primary};
  font-size: ${theme.typography.fontSize.body};
  line-height: ${theme.typography.lineHeight.relaxed};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;

export const AnnouncementContent: React.FC<{ content: string }> = ({ content }) => {
  const { t } = useTranslation('layout');
  if (!content.trim()) return null;

  return (
    <Surface aria-label={t('announcement')}>
      <Text>{content}</Text>
    </Surface>
  );
};
